import { render, staticRenderFns } from "./TVPlayingNow.vue?vue&type=template&id=4277bd73"
import script from "./TVPlayingNow.vue?vue&type=script&lang=ts"
export * from "./TVPlayingNow.vue?vue&type=script&lang=ts"
import style0 from "./TVPlayingNow.vue?vue&type=style&index=0&id=4277bd73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports